import type { HandleClientError } from "@sveltejs/kit";

const DSN = import.meta.env.PUBLIC_SENTRY_DSN as string | undefined;

let sentryModulePromise: Promise<typeof import("@sentry/sveltekit")> | null =
  null;
let sentryInitPromise: Promise<void> | null = null;

const getSentry = async () => {
  if (!sentryModulePromise) {
    sentryModulePromise = import("@sentry/sveltekit");
  }
  return sentryModulePromise;
};

const initSentry = async () => {
  if (!DSN) return;

  if (!sentryInitPromise) {
    sentryInitPromise = (async () => {
      const Sentry = await getSentry();
      Sentry.init({
        dsn: DSN,
        tracesSampleRate: 0.1,
      });
    })();
  }

  await sentryInitPromise;
};

export const init = () => {
  if (!DSN || typeof window === "undefined") return;

  const scheduleInit = () => {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(
        () => {
          void initSentry();
        },
        { timeout: 3000 },
      );
      return;
    }

    window.setTimeout(() => {
      void initSentry();
    }, 1200);
  };

  if (document.readyState === "complete") {
    scheduleInit();
    return;
  }

  window.addEventListener("load", scheduleInit, { once: true });
};

export const handleError: HandleClientError = ({ error, event }) => {
  if (!DSN) return;

  void (async () => {
    await initSentry();
    const Sentry = await getSentry();
    Sentry.captureException(error, {
      tags: {
        route: event.url.pathname,
      },
    });
  })();
};
